<template lang="pug">
    el-container.has-centered-content
        .panel-container
            .logo
                progressive-img(:src="require('@/assets/CObyVA.svg')")
            el-form.panel-form.el-form--label-left(
                ref="form"
                :model="form"
                :rules="rules"
                @submit.native.prevent="submit"
            )
                .card.z-depth-2(v-loading="loading")
                    .title-container
                        h3 {{ $t('Reset password') }}
                    el-form-item(prop="password" :label="$t('New password')" size="large")
                        el-input(
                            type="password"
                            v-model="form.password"
                            suffix-icon="el-icon-fa-key fas"
                            ref="password"
                        )
                el-form-item.buttons
                    el-button.password-reset-button(
                        type="info"
                        size="large"
                        :disabled="loading"
                        @click="$router.push('/')"
                    )
                        | {{ $t('Dismiss') }}
                    el-button.submit-button(
                        type="primary"
                        size="large"
                        :disabled="loading"
                        @click.native="submit"
                    )
                        | {{ $t('Save the new password and login') }}
</template>

<i18n>
{
  "de": {
    "Oops, an error occurred!": "Es ist ein Fehler aufgetreten!",
    "Reset password": "Passwort zurücksetzen",
    "New password": "Neues Passwort",
    "Cancel": "Abbrechen",
    "Save the new password and login": "Neues Passwort speichern und einloggen"
  }
}
</i18n>

<script>

import _ from 'lodash'

import store from '@/store'
import router from '@/router'

export default {
    name: 'ResetPassword',
    data() {
        let data = {
            form: {
                password: '',
            },
            rules: {
                password: 'required|min:6',
            },
            loading: false,
        };

        return data;
    },
    computed: {
        email() {
            return this.$route.params.email
        },
        token() {
            return this.$route.params.token
        },
    },
    methods: {
        submit() {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    this.loading = true
                    const payload = {
                        email: this.email,
                        token: this.token,
                        password: this.form.password,
                    }
                    store.dispatch('auth/resetpassword', payload)
                        .then(() => {
                            this.$message.success(this.$t('Your password has been changed successfully.'));
                            this.form.password = ''
                        })
                        .catch(error => {
                            console.error(error)
                            this.$message.error(this.$t('Oops, an error occurred!'));
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        const auth = _.get(store, 'state.auth')
        if (auth.token) next({ name: 'dashboard' })
        else next()
    }
}
</script>

<style lang="sass" scoped></style>
